import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-delete-submissions',
  templateUrl: './delete-submissions.component.html',
  styleUrls: ['./delete-submissions.component.scss']
})
export class DeleteSubmissions implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
